import { render, staticRenderFns } from "./ProvidersPage.vue?vue&type=template&id=6ac5377f"
import script from "./ProvidersPage.vue?vue&type=script&lang=js"
export * from "./ProvidersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports